
import { Component, Mixins } from "vue-property-decorator";
import { IImageContent } from "../../../../../../documaker/domain/format/objects";
import { IImageContentPropertyEditable, instanceOfIImageContentPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class ImageContentPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IImageContentPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IImageContentPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTemporaryImageContentEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIImageContentPropertyEditable(s) && s.temporaryImageContent().isEditable(), false);
  }

  get formatId(): number {
    return this.readPropertyOrDefault(s => s.formatId().getValue(), null);
  }

  get imageContent(): IImageContent {
    return this.readPropertyOrDefault(s => s.imageContent().getValue(), null);
  }

  get temporaryImageContent(): IImageContent {
    return this.readPropertyOrDefault(s => s.temporaryImageContent().getValue(), null);
  }

  set temporaryImageContent(value: IImageContent) {
    this.writePropertyWhenValid(s => s.temporaryImageContent().setValue(value));
  }
}
